import UilCheck from '@iconscout/react-unicons/icons/uil-check';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Content, PopoverStyle, Title } from './style';
import './style.css';

function Popover(props) {
  const { content, placement, title, action, children } = props;
  // Always wrap content in a div that stops propagation
  const content1 = (
    <div onClick={e => e.stopPropagation()}>
      <Content>{content}</Content>
    </div>
  );

  return (
    <PopoverStyle placement={placement} title={title && <Title>{title}</Title>} content={content1} trigger={action}>
      {children}
    </PopoverStyle>
  );
}

// Default content wrapped to prevent bubbling as well
const content = (
  <ol>
    <li>Click on the image to add a comment.</li>
    <li>Type your comment in the text box.</li>
    <li>When finished, click the blue up arrow to post the comment.</li>
    <li>Repeat for any additional comments.</li>
    <li>Click <b>Approve with Comments</b> to submit.</li>
    <li><b>Please note:</b> The comments will not be applied automatically to your image. These will be applied internally by Barksdale.</li>
  </ol>
);

Popover.defaultProps = {
  action: 'hover',
  placement: 'bottom',
  content,
};

Popover.propTypes = {
  placement: PropTypes.string,
  title: PropTypes.string,
  action: PropTypes.string,
  content: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export { Popover };
